import moment from 'moment';
import { titleize } from 'underscore.string';
import { LOCATION_TYPES } from 'constants/location';
export const DATE_FORMAT = 'MMM Do YYYY hh:mm A';
export const locationTypes = LOCATION_TYPES.map((l) => {
    return {
        name: titleize(l),
        localizationSlug: l.toUpperCase(),
        value: l.toLowerCase(),
    };
});
export function getMomentDate(date) {
    if (!date) {
        return null;
    }
    const momentDate = moment(date);
    if (momentDate.isValid()) {
        return momentDate;
    }
    return null;
}
export function getLabelInfo(referenceAccessorial) {
    let label = 'AMOUNT';
    let info = 'THE_AMOUNT';
    if (referenceAccessorial) {
        const { rate_type: rateType } = referenceAccessorial;
        if (rateType === 'daily') {
            label = 'DAYS_LABEL';
            info = 'NUMBER_OF_DAYS';
        }
        if (rateType === 'hourly') {
            label = 'HOURS_LABEL';
            info = 'NUMBER_OF_HOURS';
        }
    }
    return [label, info];
}
